export default __webpack_public_path__ + "static/door5-bc297d4b4a5e14ed770db60afbf7c1c0.jpg";